<div #scrollContainer class="container">
  <header>
    <a routerLink="/">
      <img #logo id="logo" height="300" width="150" [src]="llama[season]"
        alt="Elder llama logo - Link to the homepage"></a>
  </header>

  <main>
    <router-outlet></router-outlet>
  </main>

  <llama-fab-menu></llama-fab-menu>
</div>
